import { StyleSheet } from 'aphrodite';
import { brandPrimaryHoverTint, inputBorderColor } from '../../../../styles/colors';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	trigger: {
		height: 42,
		width: '100%',
		borderRadius: 8,
		border: `1px solid ${inputBorderColor}`,
		backgroundColor: colors.background.light,
		fontSize: 13,
		padding: '0 10px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 8,
		cursor: 'pointer',
	},
	triggerIcon: {
		flexShrink: 0,
	},
	content: {
		width: 'auto',
		padding: 12,
	},
	layout: {
		display: 'flex',
		gap: 12,
	},
	presets: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
		borderRight: `1px solid ${inputBorderColor}`,
		paddingRight: 12,
		minWidth: 120,
		justifyContent: 'center',
	},
	presetButton: {
		padding: '8px 12px',
		fontSize: 13,
		textAlign: 'left',
		borderRadius: 6,
		border: 'none',
		background: 'none',
		cursor: 'pointer',
		whiteSpace: 'nowrap',
		':hover': {
			backgroundColor: brandPrimaryHoverTint,
		},
	},
	resetContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: '8px 0 4px',
	},
});
